import { Link } from 'react-router-dom';
import type { Dispatch } from 'redux';
import { useDispatch } from 'react-redux';
import { MouseEvent, useCallback } from 'react';

import { ITableRenderCell } from 'CorePackage/TableModule/interfaces/ITableRenderCell';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';
import { ROUTE_KNM, ROUTE_KNM_LIST_WITH_PLAN, ROUTE_PLAN_BY_ID } from 'CorePackage/MainModule/routes/routes';
import { ImportFileStatusEnum } from 'APIPackage/ImportExportModule/enums/ImportFileStatusEnum';

import { IImportRow } from '../interfaces/IImportRow';
import { importDownloadWarningsFile } from '../actions/importActions';
import styles from './ImportActionsCell.module.scss';
import { importFileStatuses } from '../constants/importFileStatuses';

export function ImportActionsCell({ row, isErknm }: ITableRenderCell<IImportRow>) {
  const { filename, id, warningsFileId, planId, knmId, erpId, fileStatus } = row;
  const dispatch = useDispatch<Dispatch<RootActions>>();
  const fileStatusCode = importFileStatuses.find(status => status.name === fileStatus)?.id;
  const isError =
    fileStatusCode === ImportFileStatusEnum.PROCESSING_FAILED ||
    fileStatusCode === ImportFileStatusEnum.NOT_CREATED ||
    fileStatusCode === ImportFileStatusEnum.IMPOSSIBLE_TO_CORRECT;

  const handleErrorButtonClick = useCallback(
    (e: MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();
      if (typeof warningsFileId === 'number' && typeof filename === 'string') {
        dispatch(importDownloadWarningsFile({ id, fileName: filename }));
      }
    },
    [dispatch, filename, id, warningsFileId],
  );

  return (
    <>
      {typeof warningsFileId === 'number' && (
        <>
          <a className={styles.Link} href="/" onClick={handleErrorButtonClick}>
            Скачать файл с ошибками
          </a>
          <br />
        </>
      )}
      {(() => {
        if (planId && !isError) {
          return (
            <a
              className={styles.Link}
              href={isErknm ? ROUTE_PLAN_BY_ID(planId) : ROUTE_KNM_LIST_WITH_PLAN(planId)}
              target="_blank"
              rel="noopener noreferrer"
            >
              {`Перейти к плану (${planId})`}
            </a>
          );
        }
        if (knmId) {
          return (
            <Link className={styles.Link} to={ROUTE_KNM(knmId)}>
              {`Перейти к проверке (${erpId})`}
            </Link>
          );
        }

        return '***';
      })()}
    </>
  );
}
